import { InjectionKey } from 'vue'
import { Framework } from 'vuetify/types'

export const vuetifyKey = Symbol() as InjectionKey<Framework>
